
import { useState, useCallback } from 'react';
import axios from 'axios';
import { ApiConfig } from '../constant/constant';

const useRequest = () => {
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);

    const sendRequest = useCallback(async ({ method = '', url, headers = {}, body = '' }) => {
        setError(null);
        try {
            const config = {
                method: method,
                maxBodyLength: Infinity,
                url: `${ApiConfig.baseURL}${url}`,
                headers: {
                    ...ApiConfig.headers,
                    ...headers,
                },
                data: body,
            };

            const response = await axios.request(config);


            if (response.data?.message) {

            } else {
                setError(response?.data.message);
                throw new Error(response.data.message);
            }

            setData(response.data);
            return response.data;
        } catch (err) {
            // console.error('Error occurred:', err);
            setError(err.message || 'An unexpected error occurred.');
            throw err;
        }
    }, []);

    const sendNewRequest = useCallback(async ({ method = '', url, headers = {}, body = '' }) => {
        setError(null);
        try {
            const config = {
                method,
                maxBodyLength: Infinity,
                url: `${ApiConfig.newBaseURL}${url}`, // New base URL
                headers: {
                    ...ApiConfig.headers,
                    ...headers,
                },
                data: body,
            };

            const response = await axios.request(config);

            if (!response.data?.message) {
                setError(response?.data.message);
                throw new Error(response.data.message);
            }

            setData(response.data);
            return response.data;
        } catch (err) {
            setError(err.message || 'An unexpected error occurred.');
            throw err;
        }
    }, []);

    return { data, error, sendRequest, sendNewRequest };
};


export default useRequest;
